import { createStore, applyMiddleware, combineReducers } from "redux";
import createSagaMiddleware from "redux-saga";
import { all } from "redux-saga/effects";
import authReducer from "../reducers/authReducer";
import bookingReducer from "../reducers/bookingReducer";
import authSaga from "../sagas/authSaga";
import bookingSaga from "../sagas/bookingSaga";
import newBookingReducer from "../reducers/newBookingReducer";
import newBookingSaga from "../sagas/newBookingSaga";
import completeReducer from "../reducers/completeReducer";
import completeSaga from "../sagas/completeSaga";
import driverAttendanceReducer from "../reducers/driverAttendanceReducer";
import { watchDriverAttendance } from "../sagas/driverAttendanceSaga";
import cancelReducer from "../reducers/cancelreducer";
import { watchGetCancelByDate, watchUpdateToNewBooking } from "../sagas/cancelSaga";
import liveReducer from "../reducers/liveReducer";
import liveSaga from "../sagas/liveSaga";
import driverCallsReducer from "../reducers/driverCallsReducer";
import driverCallsSaga from "../sagas/driverCallsSaga";
import chatReducer from "../reducers/chatReducer";
import { watchChatSaga } from "../sagas/chatSaga";
import attachmentEnquiryReducer from "../reducers/AttachmentEnquiryReducer";
import { attachmentEnquirySaga } from "../sagas/AttachmentEnquirySaga";
import enterpriseEnquiryReducer from "../reducers/enterprisesEnquiryReducer";
import { enterpriseEnquirySaga } from "../sagas/enterprisesEnquirySaga";

const sagaMiddleware = createSagaMiddleware();

const rootReducer = combineReducers({
    auth: authReducer,
    booking: bookingReducer,
    newBooking: newBookingReducer,
    complete: completeReducer,
    driverAttendance: driverAttendanceReducer,
    cancel: cancelReducer,
    live: liveReducer,
    driverCalls: driverCallsReducer,
    chat: chatReducer,
    attachmentEnquiry: attachmentEnquiryReducer,
    enterpriseEnquiry: enterpriseEnquiryReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

function* rootSaga() {
    yield all([
        authSaga(),
        bookingSaga(),
        newBookingSaga(),
        completeSaga(),
        watchDriverAttendance(),
        watchGetCancelByDate(),
        watchUpdateToNewBooking(),
        liveSaga(),
        driverCallsSaga(),
        watchChatSaga(),
        attachmentEnquirySaga(),
        enterpriseEnquirySaga(),
    ]);
}

export const store = createStore(
    rootReducer,
    applyMiddleware(sagaMiddleware) as any
);

export type AppDispatch = typeof store.dispatch;

sagaMiddleware.run(rootSaga);